/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { FilterBar } from "../../../components/molecule/molecule";
import { ModalAtom, AgGridAtom } from '../../../components/atoms/atom';
import { getUserTableColumns } from './constant';
import { getSearchAddFilter } from '../../../utils/get-filter-items';
import { searchData } from '../../../utils/search';
import AddUserModal from './add/add-user';
import { setting } from '../../../store/services/index';
import { showToast, getFormattedDate, showError } from '../../../utils/method';
import SettingsMenu from '../settings-menu/settings-menu';
import './user.scss';
import { AuthContext } from "../../../contexts/AuthProvider";
  
function UserSettingPage() {
    const { t } = useTranslation();
    const { helpMode } = useContext(AuthContext);
    const [userModalView, setUserModalView] = useState('');
    const [selectedUser, setSelectedUser] = useState({});
    const [showDeleteModal, setShowdeleteModal] = useState(false);
    const filterItems = getSearchAddFilter(t, { addTextKey: 'add-user' });
    const [leftFilterItems, setLeftFilterItems] = useState(filterItems.left || []);
    const [rightFilterItems] = useState(filterItems.right || []);
    const [userList, setUserList] = useState([]);
    const [filteredUserList, setFilteredUserList] = useState([]);
   
    const fetchUsers = async () => {
        try{
            let result = await setting.getUser();
            result = (result?.data || []).map((record) => {
                return {
                    ...record,
                    provided: getFormattedDate(record.createdAt)
                }
            })
            setUserList(result);
            setFilteredUserList(result);
        } catch(error){
            showError(t, error);
        }
    }
    
    useEffect(() => {
        fetchUsers();
    }, []);
      

    const onUserEdit = (row, rowIndex) => {
        const operatingMaterial = (row?.resources || []).map((resource) => {
            return {
                label: resource?.name,
                value: resource?.id
            }
        });
        setSelectedUser({...row, operatingMaterial});
        setUserModalView('edit');
    };

    const onUserDelete = (row, rowIndex) => {
        setSelectedUser(row);
        setShowdeleteModal(true);
    }

    const onDeleteUser = async () => {
        try {
            const res = await setting.deleteUser(selectedUser?.id);
            showToast(t(res?.message), { type: 'success' });
            fetchUsers();
            setShowdeleteModal(false);
        } catch(error) {
            showToast(t(error?.message), { type: 'error' });
        }
    }

    const onAddUser = async (userInfo) => {

        try {
            const payload = {
                firstName: userInfo.firstName,
                lastName: userInfo.lastName,
                userName: userInfo.userName,
                email: userInfo.email,
                contactNumber: userInfo.contactNumber,
                resources: userInfo.operatingMaterial,
                roleId: userInfo.role,
                groupId: userInfo.group || null,
                departmentId: userInfo.department || null,
            };
            if (userModalView === 'add') {
                payload.password = userInfo.password;
                const res = await setting.addUser(payload);
                showToast(t(res?.message), { type: 'success' });
            } else if (userModalView === 'edit') {
                if (userInfo.password) {
                    payload.password = userInfo.password;
                }
                const res = await setting.updateUser(payload, userInfo.id);
                showToast(t(res?.message), { type: 'success' });
            }  
            fetchUsers();
            setUserModalView('');  
        } catch(error){
            showError(t, error);
        }
    }
    const userColumns = getUserTableColumns(t, onUserEdit, onUserDelete, helpMode);

    const onFilterAction = (index, key, info) => {
        if (key === 'search') {
            const localLeftFilterItems = [...leftFilterItems];
            localLeftFilterItems[0].value = info?.value;
            setLeftFilterItems(localLeftFilterItems);
            const filteredRoleList = searchData(info?.value, userList, userColumns.slice(0, -1));
            setFilteredUserList(filteredRoleList);
        }
        if (key === 'add') {
            setSelectedUser({});
            setUserModalView('add');
        }
    };

    return (
        <>
            <SettingsMenu />
            <FilterBar 
                leftItems={leftFilterItems}
                rightItems={rightFilterItems}
                onFilterAction={onFilterAction} />

            <AgGridAtom 
                columnDefs={userColumns}
                rowData={filteredUserList}
                enableBrowserTooltips
            />

            {userModalView && <AddUserModal
                mode={userModalView}
                userInfo={selectedUser}
                show
                onClose={() => {setUserModalView('');  setSelectedUser('')} }
                onSubmit={onAddUser}
            />}
            <ModalAtom 
                title={t('delete-user')} 
                body={<p>{t('delete-user-warning')}</p>}
                saveText = "delete"
                show={showDeleteModal} 
                handleClose={() => setShowdeleteModal(false) }
                handleSubmit={onDeleteUser }
            />
        </>
    );
}

export default UserSettingPage;
